import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { IRequestAccount } from '@core/interfaces/irequest-account';
import { IUserSearchRequest } from '@core/interfaces/i-user-search-request';
import { getSearchUrl } from './helper.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(public data: DataService) {}
  createUserRequest(payload: IRequestAccount, message?: string): Observable<any> {
    return this.data.post('user', payload, message);
  }

  getAll(): Observable<any> {
    return this.data.get('user');
  }

  search(payload: IUserSearchRequest): Observable<any> {
    const url = getSearchUrl('user/search?', payload);
    return this.data.get(url);
  }

  update(payload: any, message?: string): Observable<any> {
    return this.data.put('user', payload, message);
  }

  delete(id: number, message?: string): Observable<any> {
    return this.data.delete(`user?id=${id}`, message);
  }
}
